import { useState } from 'react'
import type { UIEvent } from 'react'

interface UseScrollProps {
  breakPoint: number
}

/**
 * 현재 해당 요소가 breakPoint 만큼 스크롤이 됐는지 확인하는 hook
 * @param breakPoint 스크롤 이벤트 감지 높이
 * @returns [boolean, (e: UIEvent<HTMLElement>) => void]
 */
function useScroll({ breakPoint }: UseScrollProps): [boolean, (e: UIEvent<HTMLElement>) => void] {
  const [isScrolling, setIsScrolling] = useState<boolean>(false)
  let timer: null | NodeJS.Timeout = null

  const onScroll = ({ currentTarget: { scrollTop } }: UIEvent<HTMLElement>) => {
    if (!isScrolling && scrollTop >= breakPoint) {
      clearTimeout(timer as NodeJS.Timeout)
      timer = setTimeout(() => {
        timer = null
        setIsScrolling(true)
      }, 10)
    }
    if (isScrolling && scrollTop < breakPoint) {
      clearTimeout(timer as NodeJS.Timeout)
      timer = setTimeout(() => {
        timer = null
        setIsScrolling(false)
      }, 10)
    }
  }

  return [isScrolling, onScroll]
}

export { useScroll }
